import script from "./BoxComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxComponent.vue?vue&type=script&setup=true&lang=js"

import "./BoxComponent.vue?vue&type=style&index=0&id=2b55b469&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b55b469"]])

export default __exports__